import React from 'react';
import { styled } from '@mui/material/styles';

const ColorCircle = styled('div')(({ status, failStatus, theme }) => ({
  width: '16px',
  height: '16px',
  borderRadius: '50%',
  backgroundColor: failStatus 
    ? '#F44336' 
    : status === 'finished' 
      ? '#4CAF50' 
      : '#9C27B0',
  display: 'inline-block',
}));

export default function StatusBadgeCircle({ status, failStatus = false }) {
  return (
    <ColorCircle status={status} failStatus={failStatus} />
  );
}